import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class BuyerCantBeTheSameAsClientError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.client.validation.buyer.same-as-original');
    }
}
